import request from "../../untils/request";

export function testInternetSpeed(param) {

    return request({
        url: '/systemTools/testInternetSpeed',
        method: 'get',
        params:param
    })
}


